export default "__VITE_ASSET__CQI01wzA__"